import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/login.vue'
import Layout from '@/views/layout.vue'
import Dashboard from '@/views/dashboard.vue'
import UserList from '@/views/user/list.vue'
import TeamList from '@/views/team/list.vue'
import WorkList from '@/views/work/list.vue'
import SettlementList from '@/views/settlement/list.vue'
import AdvanceList from '@/views/advance/list.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '首页' }
      },
      {
        path: 'user',
        name: 'UserList',
        component: UserList,
        meta: { title: '用户管理' }
      },
      {
        path: 'team',
        name: 'TeamList',
        component: TeamList,
        meta: { title: '项目管理' }
      },
      {
        path: 'work',
        name: 'WorkList',
        component: WorkList,
        meta: { title: '工时管理' }
      },
      {
        path: 'advance',
        name: 'AdvanceList',
        component: AdvanceList,
        meta: { title: '借支管理' }
      },
      {
        path: 'settlement',
        name: 'SettlementList',
        component: SettlementList,
        meta: { title: '结算管理' }
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  if (to.path !== '/login' && !token) {
    next('/login')
  } else {
    next()
  }
})

export default router
